import * as DOMPurify from "dompurify";
import * as moment from "moment";
import { VettingRuleEntityUris } from "../constants/vetting/vetting.constants";
import { DataType } from "../models/queries/queries.models";
import { RuleDisplayResultItem } from "../models/rules/rules.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

export class RuleDisplayResultHelper {
    public static beatifyResultHtml(item: RuleDisplayResultItem, isRightShipUser: boolean): string {
        const div = document.createElement('div');

        //Re-add target _blank to all A tags since DOMPurify.sanitize removes it
        DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
            if ('setAttribute' in node && node.tagName == 'A') {
                node.setAttribute('target', '_blank');
            }
        });
        div.innerHTML = DOMPurify.sanitize(item.text);
        
        const doubleSpans: Element[] = Array.from(div.querySelectorAll("span[data-type='4']"));
        const urlSpans: Element[] = Array.from(div.querySelectorAll("span[data-type='11']"));
        const bitSpans: Element[] = Array.from(div.querySelectorAll("span[data-type='2']"));
        const ghgSpans: Element[] = Array.from(div.querySelectorAll("span[data-type='1004']"));
        let dateSpans: Element[] = Array.from(div.querySelectorAll("span[data-type='12']"));
        dateSpans = dateSpans.concat(Array.from(div.querySelectorAll("span[data-type='7']")));
        const spans: Element[] = Array.from(div.querySelectorAll("span[data-type='1']"));

        doubleSpans.forEach(span => {
            const value = span.textContent;
            span.textContent = Number(value).toFixed(2);
        });

        spans.forEach(span => {
            if (!span.textContent) {
                span.textContent = 'Not Available';
            }
        })
        urlSpans.forEach(span => {
            if (!span.textContent) {
                span.textContent = 'Not Available';
                return;
            }
            const id = span.textContent;

            let href = "";
            let text = "";
            if (item.uri == VettingRuleEntityUris.VettingRuleCompanyAssociations) {
                href = '/company/' + id;
                text = 'Company Link';
            }
            else if (item.uri == VettingRuleEntityUris.VettingRuleVesselIncidents) {
                href = '/incident/' + id;
                text = 'INC';
            } else if (item.uri == VettingRuleEntityUris.VettingRuleVesselPscs || item.uri == VettingRuleEntityUris.VettingRuleVesselPscDeficiencies) {
                href = '/psc/' + id;
                text = 'PSC';
            } else if (item.uri == VettingRuleEntityUris.FBRs || item.uri == VettingRuleEntityUris.VettingRuleFbrAggregate) {
                href = '/fbr/' + id;
                text = 'FBR';
            } else if (item.uri == VettingRuleEntityUris.VettingRuleVets) {
                href = '/vet/' + id;
                text = 'VET';
            } else if (item.uri == VettingRuleEntityUris.VettingRuleVesselCSSR) {
                href = '/vet-task-onboarding-custom-content?vesselApplicationFormId=' + id;
                text = 'CSSR';
            } 
            span.innerHTML = "<a href='" + href + "' target='_blank'>" + text + "</a>"
        });

        bitSpans.forEach(span => {
            const value = span.textContent;
            span.textContent = value.toLowerCase() == "true" ? "Yes" : "No";
        });

        ghgSpans.forEach(span => {
            const weight = span.textContent;
            let letter = "";
            if (weight.startsWith("8")) {
                letter = "A";
            }
            else if (weight.startsWith("7")) {
                letter = "B";
            }
            else if (weight.startsWith("6")) {
                letter = "C";
            }
            else if (weight.startsWith("5")) {
                letter = "D";
            }
            else if (weight.startsWith("4")) {
                letter = "E";
            }
            else if (weight.startsWith("3")) {
                letter = "F";
            }
            else if (weight.startsWith("2")) {
                letter = "G";
            }
            else if (weight.startsWith("1")) {
                letter = "U";
            }

            const ratingPlus = weight.endsWith("6") ||
                weight.endsWith("2") ? "+" : "";

            const verified = weight.endsWith("6") ||
                weight.endsWith("4") ? " (Verified)" : " (Unverified)";

            span.textContent = letter + ratingPlus + verified;
        });

        dateSpans.forEach(span => {
            if (!span.textContent) {
                span.textContent = 'Not Available';
                return;
            }
            const value = span.textContent;
            const date = moment.utc(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY H:mm:ss", "DD/MM/YYYY hh:mm:ss A", "DD/MM/YYYY h:mm:ss A", "YYYY-MM-DDTHH:mm:ss.fffZ"]).local();
            const parameters = span.getAttribute('parameters');

            const dataType = Number(span.getAttribute('data-type'));
            let datestring = null;

            if (parameters && parameters != null && parameters != "") {
                datestring = date.format(parameters);
            }
            else {
                datestring = date.format(dataType == DataType.Date ? ConfigService.instance().config.common.defaultDateFormat : ConfigService.instance().config.common.defaultDateTimeFormat);
            }
            span.textContent = date.isValid() ? datestring : value;
        });

        if (isRightShipUser && item.uri == VettingRuleEntityUris.VettingRuleVesselPscs) {            
            const statusSpans: Element[] = Array.from(div.querySelectorAll("span[data-property-name='pscInspectionStatus']"));
            
            statusSpans.forEach(span => {
                const status = span.textContent;

                if(status.toLowerCase() == "clean")
                {
                    span.textContent = "Created";
                }
            });
        }

        return div.innerHTML;
    }
}